import { render } from "./BindYh.vue?vue&type=template&id=6f8765d4&scoped=true"
import script from "./BindYh.vue?vue&type=script&lang=js"
export * from "./BindYh.vue?vue&type=script&lang=js"

import "./BindYh.vue?vue&type=style&index=0&id=6f8765d4&scoped=true&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8765d4"]])

export default __exports__